export default __webpack_public_path__ + "static/media/TodaysFocus_empty.ab58cb7a.png";